/**
 * The hero — a hooded developer, flat on the left of the seam (the front)
 * and wireframe on the right (the back). Wireframe strokes carry
 * `.hoodie__stroke` so DrawSVG can draw them in.
 *
 * @module scenes/hoodie
 */

import { MARK_LEFT, MARK_RIGHT } from '../components/icons.js';
import { scene } from './svg.js';

const HOOD = 'M150 400 C 138 220, 210 110, 300 106 C 390 110, 462 220, 450 400 C 410 450, 190 450, 150 400 Z';
const BODY = 'M60 640 C 80 470, 170 405, 300 398 C 430 405, 520 470, 540 640 Z';
const POCKET = 'M205 640 L215 598 Q300 574 385 598 L395 640';

/** The logo mark, printed on the chest. */
const ON_CHEST = 'translate(300 548) scale(.4) translate(-259 -273)';

/**
 * @param {string} id - Unique per page: prefixes the clip paths.
 * @returns {import('../lib/html.js').Markup}
 */
export function hoodie(id) {
    let scanLines = '';

    for (let y = 118; y <= 636; y += 24) {
        scanLines += `<line class="hoodie__stroke" x1="300" y1="${y}" x2="560" y2="${y}"/>`;
    }

    const clips =
        '<defs>' +
        `<clipPath id="${id}-front"><rect x="0" y="0" width="300" height="640"/></clipPath>` +
        `<clipPath id="${id}-back"><rect x="300" y="0" width="300" height="640"/></clipPath>` +
        `<clipPath id="${id}-shape"><path d="${HOOD}"/><path d="${BODY}"/></clipPath>` +
        '</defs>';

    const flat =
        `<g clip-path="url(#${id}-front)">` +
        `<path class="hoodie__body" d="${BODY}"/>` +
        `<path class="hoodie__pocket" d="${POCKET} Z"/>` +
        `<path class="hoodie__hood" d="${HOOD}"/>` +
        '<ellipse class="hoodie__face" cx="300" cy="300" rx="92" ry="112"/>' +
        '<rect class="hoodie__glass" x="243" y="282" width="46" height="26" rx="6"/>' +
        '<path class="hoodie__string" d="M268 420 L262 498"/>' +
        '<circle class="hoodie__knot" cx="262" cy="502" r="6"/>' +
        `<g class="hoodie__mark" transform="${ON_CHEST}"><path d="${MARK_LEFT}"/><path d="${MARK_RIGHT}"/></g>` +
        '</g>';

    const wireframe =
        `<g class="hoodie__wire" clip-path="url(#${id}-back)">` +
        `<g class="hoodie__scan" clip-path="url(#${id}-shape)">${scanLines}</g>` +
        `<path class="hoodie__stroke" d="${BODY}"/>` +
        `<path class="hoodie__stroke" d="${HOOD}"/>` +
        '<ellipse class="hoodie__stroke hoodie__stroke--face" cx="300" cy="300" rx="92" ry="112"/>' +
        '<rect class="hoodie__stroke" x="311" y="282" width="46" height="26" rx="6"/>' +
        '<path class="hoodie__stroke" d="M289 295 L311 295"/>' +
        '<path class="hoodie__stroke" d="M332 420 L338 498"/>' +
        '<circle class="hoodie__stroke" cx="338" cy="502" r="6"/>' +
        `<path class="hoodie__stroke" d="${POCKET}"/>` +
        `<g transform="${ON_CHEST}"><path class="hoodie__stroke hoodie__stroke--mark" d="${MARK_RIGHT}"/></g>` +
        '</g>';

    const seam = '<line class="hoodie__seam" x1="300" y1="80" x2="300" y2="640"/>';

    return scene('0 0 600 640', clips + flat + wireframe + seam, 'xMidYMax meet');
}
